import { Route, Routes } from "react-router";
import { Login } from "./pages/login";
import { NewAccount } from "./pages/newAccount";
import { ForgotPassword } from "./pages/recoverPassword";
import { Home } from "./pages/home";
import { Stores } from "./pages/stores/List";
import { Clients } from "./pages/clients";
import { Sales } from "./pages/sales";
import { StoreForm } from "./pages/stores/Form";
import { Users } from "./pages/users/List";
import { UserForm } from "./pages/users/Form";
import { NewPassword } from "./pages/newPassword";
import { useLogin } from "./hooks/useLogin";
import { Navigate } from "react-router-dom";
import { ProfileTypeEnum } from "./pages/users/enums";
import { useCustomToast } from "./hooks/useToast";
import { Events } from "./pages/events/List";
import { EventsForm } from "./pages/events/Form";
import { EventClients } from "./pages/events/EventClients";
import { EventEntrance } from "./pages/events/EventEntrance";
import { PickupReport } from "./pages/events/PickupReport";
import { Parameterization } from "./pages/parameterization/List/parameterization";
import { EntranceReport } from "./pages/events/EntranceReport";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" Component={Login} />
      <Route path="/criar-conta" Component={NewAccount} />
      <Route path="/recuperar-senha" Component={ForgotPassword} />
      <Route path="/alterar-senha/:token" Component={NewPassword} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/eventos" replace />} />
      <Route path="/lojas" Component={Stores} />
      <Route path="/loja/:storeId/clientes" Component={Clients} />
      <Route path="/loja/:storeId/vendas" Component={Sales} />
      <Route path="/loja/cadastro" Component={StoreForm} />
      <Route path="/loja/editar/:id" Component={StoreForm} />
      <Route path="/usuarios" Component={Users} />
      <Route path="/usuario/cadastro" Component={UserForm} />
      <Route path="/usuario/editar/:id" Component={UserForm} />
      <Route path="/eventos" Component={Events} />
      <Route path="/eventos/cadastro" Component={EventsForm} />
      <Route path="/eventos/editar/:id" Component={EventsForm} />
      <Route path="/eventos/:eventId/clientes" Component={EventClients} />
      <Route path="/eventos/usuarios-portaria/:id" Component={EventEntrance} />
      <Route path="/eventos/relatorio-retirada/:id" Component={PickupReport} />
      <Route path="/eventos/relatorio-acesso/:id" Component={EntranceReport} />
      <Route path="/parametrizacoes" Component={Parameterization} />
    </Routes>
  );
};

const ProtectedRoute = ({ children }: any) => {
  const { isAuthenticated, getAccount } = useLogin();
  const { customToast } = useCustomToast();

  if (
    !isAuthenticated ||
    getAccount()?.profile !== ProfileTypeEnum.administrador
  ) {
    customToast("warning", "A conta não possui as permissões necessárias.");
    return <Navigate to="/login" replace />;
  }

  return children;
};
